import type {
  CustomizationCategory,
  MaterialPaintRegions,
} from '../../constants/customizationCategories';

export const isCobrandCategory = (
  brandTypes: MaterialPaintRegions[] | undefined,
  category: CustomizationCategory | null,
) => {
  if (!brandTypes || !category) return false;

  return (
    (brandTypes.includes('paint') && category.type === 'paint') ||
    (brandTypes.includes(category.region) && category.type !== 'paint')
  );
};
